import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.less';
import Sider from 'antd/es/layout/Sider';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import useMobileBreakpoint from '../../../../hooks/useMobileBreakpoint';

const TriptychLayoutPrepend = ({ children, noPadding }) => {
  const screens = useBreakpoint();

  const hasSmallPadding = !screens.xl;

  const isMobile = useMobileBreakpoint();

  const className = classNames('triptych-layout__prepend', {
    'triptych-layout__prepend--no-padding': noPadding,
    'triptych-layout__prepend--small-padding': (isMobile || hasSmallPadding) && !noPadding,
    'triptych-layout__prepend--mobile': isMobile,
  });

  return <Sider className={className}>{children}</Sider>;
};

TriptychLayoutPrepend.propTypes = {
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool,
};

TriptychLayoutPrepend.defaultProps = {
  noPadding: false,
};

export default TriptychLayoutPrepend;
